import { useState, useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { TripContext } from "../context";
import { getData } from "../common/strapiUrl";

const TripProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [bookingData, setBookingData] = useState({});
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [travelStylesOptions, setTravelStylesOptions] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [pages, setPages] = useState([]);
  useLayoutEffect(() => {
    getData("/pages").then((res) => {
      setPages(res?.data);
      // console.log(res?.data, "res");
    });
  }, []);

  useEffect(() => {
    setBookingData({});
  }, [pathname]);

  return (
    <TripContext.Provider
      value={{
        pages,
        bookingData,
        setBookingData,
        citiesOptions,
        setCitiesOptions,
        countriesOptions,
        setCountriesOptions,
        travelStylesOptions,
        setTravelStylesOptions,
        destinationOptions,
        setDestinationOptions,
      }}
    >
      {children}
    </TripContext.Provider>
  );
};

export default TripProvider;
